import _ from "underscore";
export const templateStages = {
    getAttention: {
        className: "approached",
        templates: ["APPROACHED", "APPROACHED_FU"],
        chatToEmail: false,
    },
    engage: {
        className: "engaged",
        templates: ["ENGAGED", "ENGAGED_FU"],
        chatToEmail: true,
    },
    handover: {
        className: "handover",
        templates: ["HANDOVER", "HANDOVER_FU"],
        chatToEmail: true,
    },
    meetingSchedulerResponses: {
        className: "handover",
        templates: ["MEETING_INVITE", "MEETING_CONFIRMATION", "MEETING_NOT_FREE", "MEETING_REMINDER", "RESCHEDULE", "INVITE_RESENT_CONFIRMATION", "CALL_ME"],
        chatToEmail: true,
    },
    ended: {
        className: "ended",
        templates: ["LEAD_OPTED_OUT", "LEAD_NOT_FIT", "WRONG_PERSON", "NOT_INTERESTED", "EXISTING_CUSTOMER", "EXISTING_PROSPECT"],
        chatToEmail: true,
    },
    outOfOfficeAndContactMeLater: {
        className: "contact-later",
        templates: ["OOO_REENGAGE", "CONTACT_ME_LATER_APPROVE", "CONTACT_LATER_REENGAGE"],
        chatToEmail: true,
    },
    others: {
        className: "others",
        templates: ["DEFAULT_EMAIL", "LOOP_BACK_IN", "REFERRAL_APPROACHED"],
        chatToEmail: true,
    },
};

export const templateTypes = {
    APPROACHED: {
        name: 'Intro',
        sendWithoutApproval: true,
        bgClassName: 'bg-approached',
        borderClassName: 'border-approached',
        standalone: true,
        chatToEmail: false,
        vaReport: true,
    },
    APPROACHED_FU: {
        name: 'Approached User Follow Up',
        numberedName: 'Approached Follow Up #',
        sendWithoutApproval: true,
        bgClassName: 'bg-approached',
        borderClassName: 'border-approached',
        followupOf: "APPROACHED",
        isFollowup: true,
        chatToEmail: false,
        vaReport: true,
    },
    ENGAGED: {
        name: 'Engaged',
        sendWithoutApproval: false,
        bgClassName: 'bg-engaged',
        borderClassName: 'border-engaged',
        chatToEmail: false,
        canBeTextMsg : true
    },
    ENGAGED_FU: {
        name: 'Engaged User Follow Up',
        numberedName: 'Engaged Follow Up #',
        sendWithoutApproval: true,
        bgClassName: 'bg-engaged',
        borderClassName: 'border-engaged',
        followupOf: "ENGAGED",
        isFollowup: true,
        chatToEmail: true,
        vaReport: true,
    },
    HANDOVER: {
        name: 'Rep Handover Qualified',
        sendWithoutApproval: false,
        bgClassName: 'bg-assigned',
        borderClassName: 'border-assigned',
        displayName: 'Handover',
        chatToEmail: true,
        ccAssignedRep: true,
        canBeTextMsg: true,
        addThreadCCs: true,
    },
    HANDOVER_FU: {
        name: 'Handover Follow Up',
        numberedName: 'Handover Follow Up #',
        sendWithoutApproval: false,
        bgClassName: 'bg-assigned',
        borderClassName: 'border-assigned',
        followupOf: "HANDOVER",
        isFollowup: true,
        chatToEmail: true,
        ccAssignedRep: true,
    },
    MEETING_CONFIRMATION: {
        name: 'Scheduled Meeting Confirmation',
        sendWithoutApproval: true,
        bgClassName: 'bg-assigned',
        borderClassName: 'border-assigned',
        displayName: 'Meeting Confirmation',
        chatToEmail: true,
    },
    MEETING_REMINDER : {
        name: 'Meeting Reminder',
        sendWithoutApproval: true,
        bgClassName: 'bg-assigned',
        borderClassName: 'border-assigned',
        displayName: 'Meeting Reminder',
        standalone: true,
        simpleTemplate: true,
        chatToEmail: true,
        ccAssignedRep: true,
    },
    MEETING_NOT_FREE: {
        name: 'Meeting Time Not Free',
        sendWithoutApproval: false,
        bgClassName: 'bg-assigned',
        borderClassName: 'border-assigned',
        displayName: 'Alternative Time Suggestions',
        chatToEmail: true,
        ccAssignedRep: true,
    },
    LOOP_BACK_IN: {
        name: 'Rep Loop Back In',
        sendWithoutApproval: false,
        bgClassName: 'bg-assigned',
        borderClassName: 'border-assigned',
        displayName: 'Loop Rep Back In',
        chatToEmail: true,
        ccAssignedRep: true,
    },
    RESCHEDULE: {
        name: 'Reschedule',
        sendWithoutApproval: false,
        bgClassName: 'bg-assigned',
        borderClassName: 'border-assigned',
        displayName: 'Reschedule Meeting',
        chatToEmail: true,
        ccAssignedRep: true,
    },
    INVITE_RESENT_CONFIRMATION: {
        name: 'Invite Resent Confirmation',
        sendWithoutApproval: false,
        bgClassName: 'bg-assigned',
        borderClassName: 'border-assigned',
        displayName: 'Resend Invite Confirmation',
        chatToEmail: true,
        ccAssignedRep: true,
    },
    NOT_INTERESTED: {
        name: 'Not Interested',
        sendWithoutApproval: false,
        bgClassName: 'bg-ended',
        borderClassName: 'border-ended',
        displayName: 'Not Interested',
        chatToEmail: true,
        canBeTextMsg: true,
    },
    LEAD_NOT_FIT: {
        name: 'Lead Not Fit',
        sendWithoutApproval: false,
        bgClassName: 'bg-ended',
        borderClassName: 'border-ended',
        displayName: 'Not a Good Fit',
        chatToEmail: true,
    },
    WRONG_PERSON: {
        name: 'Wrong Person',
        sendWithoutApproval: false,
        bgClassName: 'bg-ended',
        borderClassName: 'border-ended',
        displayName: 'Wrong Person',
        chatToEmail: true,
    },
    LEAD_OPTED_OUT: {
        name: 'Lead Opted Out',
        sendWithoutApproval: true,
        bgClassName: 'bg-ended',
        borderClassName: 'border-ended',
        displayName: 'Opt-out Confirmation',
        chatToEmail: true,
        canBeTextMsg: true,
    },
    OOO_REENGAGE: {
        name: 'Out Of Office Reengage',
        sendWithoutApproval: true,
        bgClassName: 'bg-ooo',
        borderClassName: 'border-ooo',
        displayName: 'Out-of-office Re-engage',
        chatToEmail: true,
    },
    CONTACT_LATER_REENGAGE: {
        name: 'Contact Me Later Reengage',
        sendWithoutApproval: true,
        bgClassName: 'bg-ooo',
        borderClassName: 'border-ooo',
        displayName: 'Contact Later Re-engage',
        chatToEmail: true,
    },
    CONTACT_ME_LATER_APPROVE: {
        name: 'Contact Me Later Approve',
        sendWithoutApproval: false,
        bgClassName: 'bg-ooo',
        borderClassName: 'border-ooo',
        displayName: 'Contact Later',
        chatToEmail: true,
    },
    DEFAULT_EMAIL: {
        name: 'Default Email',
        sendWithoutApproval: false,
        bgClassName: 'bg-danger',
        borderClassName: 'border-danger',
        displayName: 'Generic Template',
        chatToEmail: true,
        canBeTextMsg: true,
    },
    EXISTING_CUSTOMER: {
        name: 'Existing Customer',
        sendWithoutApproval: false,
        bgClassName: 'bg-ended',
        borderClassName: 'border-ended',
        chatToEmail: true,
    },
    EXISTING_PROSPECT: {
        name: 'Existing Prospect',
        sendWithoutApproval: false,
        bgClassName: 'bg-ended',
        borderClassName: 'border-ended',
        chatToEmail: true,
    },
    MEETING_INVITE: {
        name: 'Meeting Invite',
        sendWithoutApproval: true,
        bgClassName: 'bg-assigned',
        borderClassName: 'border-assigned',
        standalone: true,
        simpleTemplate: true,
        chatToEmail: true,
    },
    STANDALONE: {
        name: 'Standalone',
        sendWithoutApproval: false,
        bgClassName: 'bg-engaged',
        borderClassName: 'border-engaged',
        displayName: 'Standalone Message',
        chatToEmail: true,
    },
    REFERRAL_APPROACHED: {
        name: 'Referral Intro',
        sendWithoutApproval: true,
        bgClassName: 'bg-approached',
        borderClassName: 'border-approached',
        forward: true,
        chatToEmail: false,
    },
    CALL_ME: {
        name: 'Call Me',
        sendWithoutApproval: true,
        bgClassName: 'bg-assigned',
        borderClassName: 'border-assigned',
        ccAssignedRep: true,
        canBeTextMsg: true,
    },
};

export const followupsMap = {
    APPROACHED_USER_FOLLOW_UP: templateTypes.APPROACHED_FU,
    ENGAGED_USER_FOLLOW_UP: templateTypes.ENGAGED_FU,
    HANDOVER_FOLLOW_UP: templateTypes.HANDOVER_FU,
};

export const SequenceTypes = {
    EMAIL: {
        name: 'EMAIL',
        displayName: 'Email',
        desc: 'Email only Sequence',
        iconTypes: ['mail'],
    },
    CHAT: {
        name: 'CHAT',
        displayName: 'Chat',
        desc: 'Chat only Sequence',
        iconTypes: ['message'],
    }
};

export const findTemplateByName = (templateName) => {
    return _.find(templateTypes, template => templateName === template.name || (template.isFollowup && templateName.startsWith(template.numberedName)));
};
